import styled from "styled-components";
export const Price = styled.span.withConfig({
    displayName: "styled__Price",
    componentId: "sc-f1636338-0"
})`
	--price-font-size: 100%;

	${({ $size =0  })=>$size > 5 && '--price-font-size: 80%;'};

	font-size: var(--price-font-size);
	font-size: max(15px, var(--price-font-size));
	line-height: 100%;
`;
export const Currency = styled.span.withConfig({
    displayName: "styled__Currency",
    componentId: "sc-f1636338-1"
})`
	--currency-font-size: 80%;

	&.small {
		--currency-font-size: 70%;
	}

	font-size: var(--currency-font-size);
	font-size: max(13px, var(--currency-font-size));
`;

//# sourceMappingURL=styled.js.map